<template>
	<div class="interviewbogen">
		<!--
		<h2>{{interviewleitfaden[page].titel}}</h2>
		<p>{{interviewleitfaden[page].erlaeuterung}}</p>
		<p>{{interviewleitfaden[page].beispielfrage}}</p>
		<h2>Einschätzung</h2>
		<p>{{skala.instruktion}}</p>
		<ul class="kategorien">
			<li class="kategorie avbi" v-for="(ankerx, index) in skala.anker" :key="index">
				<input type="radio"
					:id="skala.fragen[page-1].skala + '_' + skala.fragen[page-1].item + '_' + ankerx.wert"
					:name="skala.fragen[page-1].skala + '_' + skala.fragen[page-1].item"
					:checked="bereitsAusgewaehlt(skala.fragen[page-1].skala + '_' + skala.fragen[page-1].item, ankerx.wert)"
					@click="antwortItem(skala.fragen[page-1].skala + '_' + skala.fragen[page-1].item, ankerx.wert)"
				/>
				<label :for="skala.fragen[page-1].skala + '_' + skala.fragen[page-1].item + '_' + ankerx.wert">
					<img class="avbi" :src="avbiUrl(skala.fragen[page-1].item, ankerx.wert)" />
				</label>
			</li>
		</ul>
		<v-pagination v-model="page" circle :length="7" :total-visible="7"></v-pagination>
		-->
		<h1>Interviewbogen</h1>
		<p>Auf dieser Seite finden Sie einen Interviewbogen, der Sie bei der Begehung eines Arbeitsplatzes unterstützt. Das Interview ist dabei nach den sieben Facetten der Arbeitsdichte gegliedert. Bitte geben Sie mit den Beschäftigen jede Facette einzeln durch, indem Sie nacheinander die Tabs auswählen. Jedes Tab enthält dabei eine kurze Erläuterung der jeweiligen Facette und Sie erhalten mögliche Beispielfragen, die Sie dem Beschäftigten stellen können.</p>
		<p>Hilfestellung für das Interview finden Sie zu jeder Facette eine Bilderfolge, welche die Facette illustiert. Diese Bilderfolge dient auch zur Abgabe ihrer Einschätzung. Sobald Sie alle Facetten eingeschätzt haben, können Sie den Fragebogen abschicken und erhalten eine automatisierte Auswertung.</p>
		<v-tabs v-model="tab" grow>
			<v-tab v-for="(frage, fragex) in skala.fragen" :key="fragex">{{interviewleitfaden[parseInt(frage.item)].titel}}</v-tab>
		</v-tabs>
		<v-tabs-items v-model="tab">
			<v-tab-item v-for="(frage, fragex) in skala.fragen" :key="fragex" transition="null" reverse-transition="null">
				<h2>{{interviewleitfaden[parseInt(frage.item)].titel}}</h2>
				<p>{{interviewleitfaden[parseInt(frage.item)].erlaeuterung}}</p>
				<p>{{interviewleitfaden[parseInt(frage.item)].beispielfrage}}</p>
				<h2>Einschätzung</h2>
				<p>{{skala.instruktion}}</p>
				<ul class="kategorien">
					<li class="kategorie avbi" v-for="(ankerx, index) in skala.anker" :key="index">
						<input type="radio"
							:id="frage.skala + '_' + frage.item + '_' + ankerx.wert"
							:name="frage.skala + '_' + frage.item"
							@click="antwortItem(frage.skala + '_' + frage.item, ankerx.wert)"
						/>
						<label :for="frage.skala + '_' + frage.item + '_' + ankerx.wert">
							<img class="avbi" :src="avbiUrl(frage.item, ankerx.wert)" />
						</label>
					</li>
				</ul>
			</v-tab-item>
		</v-tabs-items>
		<!--
		<v-carousel :continuous="false" :show-arrows="false">
			<v-carousel-item v-for="(frage, fragex) in skala.fragen" :key="fragex" color="primary">
				<v-sheet light>
					<h2>{{interviewleitfaden[parseInt(frage.item)].titel}}</h2>
					<p>{{interviewleitfaden[parseInt(frage.item)].erlaeuterung}}</p>
					<p>{{interviewleitfaden[parseInt(frage.item)].beispielfrage}}</p>
					<h2>Einschätzung</h2>
					<p>{{skala.instruktion}}</p>
					<ul class="kategorien">
						<li class="kategorie avbi" v-for="(ankerx, index) in skala.anker" :key="index">
							<input type="radio"
								:id="frage.skala + '_' + frage.item + '_' + ankerx.wert"
								:name="frage.skala + '_' + frage.item"
								@click="antwortItem(frage.skala + '_' + frage.item, ankerx.wert)"
							/>
							<label :for="frage.skala + '_' + frage.item + '_' + ankerx.wert">
								<img class="avbi" :src="avbiUrl(frage.item, ankerx.wert)" />
							</label>
						</li>
					</ul>
				</v-sheet>
			</v-carousel-item>
		</v-carousel>
		-->
		<div style="margin-top:2em;text-align:center;"><v-btn @click="einschaetzungAbschicken()" :disabled="antwortenFehlen">Einschätzung abschicken</v-btn></div>
	</div>
</template>
<script>
	import axios from 'axios';
	export default {
		name: 'Interviewbogen',
		data: function() {
			return {
				interviewleitfaden: {
					1: {titel: 'Menge', erlaeuterung: 'Erläuterung Facette 1', beispielfrage: 'Beispielfrage Facette 1'},
					2: {titel: 'Unterbrechungen', erlaeuterung: 'Erläuterung Facette 2', beispielfrage: 'Beispielfrage Facette 2'},
					3: {titel: 'Gleichzeitigkeit ', erlaeuterung: 'Erläuterung Facette 3', beispielfrage: 'Beispielfrage Facette 3'},
					4: {titel: 'Interdependenz', erlaeuterung: 'Erläuterung Facette 4', beispielfrage: 'Beispielfrage Facette 4'},
					5: {titel: 'Arbeitsspitzen', erlaeuterung: 'Erläuterung Facette 5', beispielfrage: 'Beispielfrage Facette 5'},
					6: {titel: 'Erreichbarbeit', erlaeuterung: 'Erläuterung Facette 6', beispielfrage: 'Beispielfrage Facette 6'},
					7: {titel: 'Unklarheit', erlaeuterung: 'Erläuterung Facette 7', beispielfrage: 'Beispielfrage Facette 7'},
				},
				fragebogen: 'avbi',
				page: 1,
				skala: {},
				fragebogenAntworten: {},
				tab: 0,
				antwortenFehlen: true
			}
		},
		created() {
			this.skalenHolen();
		},
		computed: {
			teilnehmer() {
				return this.$store.state.teilnehmer;
			}
		},
		methods: {
			async skalenHolen() {
				try {
					const response = await axios.get('https://www.arbeitsverdichtung.de/api/skalen', {
						params: {
							e: [this.fragebogen]
						}
					})
					const data = await response;
					this.skala = data.data[0];
					console.log('Skala');
					console.log(this.skala);
				} catch (error) {
					alert(error);
				}
			},
			antwortItem: function(item, antwort) {
				console.log(item+' / '+antwort);
				this.fragebogenAntworten[item] = antwort;
				console.log(this.fragebogenAntworten);
				// this.bereitsAusgewaehlt(item, antwort);
				if (Object.keys(this.fragebogenAntworten).length >= 7) {
					this.antwortenFehlen = false;
					}
				else {
					this.antwortenFehlen = true;
				}
			},
			bereitsAusgewaehlt: function(item, antwort) {
				var ergebnis = Boolean;
				// console.log(item);
				// console.log(antwort);
				// console.log(this.antworten);
				if (this.fragebogenAntworten[item] == antwort) {
					// console.log('match');
					ergebnis = true;
				}
				else {
					ergebnis = false;
				}
				return ergebnis;
			},
			einschaetzungAbschicken: function() {
				axios.post('https://www.arbeitsverdichtung.de/api/fragebogen', {
					teilnehmer: this.teilnehmer,
					erhebung: '1',
					fragebogenAntworten: this.fragebogenAntworten
				})
				.then(response => {
					console.log(response);
					this.$router.push({path: '/auswertung'});
				})
				.catch(error => {
					console.log(error);
				});
			},
			avbiUrl: function(item, auspraegung) {
				var images = require.context('../assets/', false, /\.png$/);
				var b = String;
				if (auspraegung == 1) { b = 'a'; }
				if (auspraegung == 2) { b = 'b'; }
				if (auspraegung == 3) { b = 'c'; }
				if (auspraegung == 4) { b = 'd'; }
				if (auspraegung == 5) { b = 'e'; }
				var url = images('./avbi0' + item + b + '.png');
				return url;
			}
		},
		watch: {
			// page: function() {
			// 	console.log(this.antworten);
			// }
		}
	}
</script>
<style scoped>
	.v-tab {
		color: #ffffff !important;
		background-color: #055d05;
		border-top: solid 2px #055d05;
		border-left: solid 2px #055d05;
		border-right: solid 2px #055d05;
	}	
	.v-tab--active {
		color: #055d05 !important;
		background-color: #ffffff;
		border-bottom-color: #ffffff !important;
	}
	.v-tabs-items {
		border: solid 2px #055d05;
		border-top: 0px;
		padding: 0.5em;
	}
	.v-carousel__controls {
		background-color: '#ffffff';
		color: '#000000';
	}
	ul.kategorien {
		display: table;
		margin: auto;
		padding: 0em;
	}
	li.kategorie.avbi {
		display: table-cell;
		vertical-align: middle;
		text-align: center;
		font-weight: bold;
		padding: 0em;
		max-width: 8em;
	}
	li.kategorie.avbi input[type=radio] {
		display: none;
	}
	li.kategorie.avbi label {
		display: block;
		text-align: center;
		line-height: 0.8em;
		margin: 0.5em;
	}
	li.kategorie.avbi label:hover {
		background-color: #ffffcd;
	}
	li.kategorie.avbi input[type=radio] + label {
		cursor: pointer;
	}
	li.kategorie.avbi input[type=radio]:checked + label {
		background-color: #FACC2E;
	}
	li.kategorie.avbi label img {
		width: 100%;
	}
</style>
